import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import trans from '../../translations.json';
import { getDatesRange, dateFormater } from '../utils';
const sourcesToDisplay = [
  'Travel',
  'CC',
  'No known epi link',
  'OB',
  'Unspecified epi link',
];

const latestDate = Object.keys(
    ReducedData.dataSourceAll[dict.sourcesAll['No known epi link']],
  )
    .sort((a, b) => new Date(a) - new Date(b))
    .pop(),
  dateRange = getDatesRange('2020-01-15', latestDate);

class BySourceTable extends React.Component {
  state = {
    data: undefined,
    dateRange: dateRange,
  };

  render() {
    var previousDayData;
    var tableData = this.state.dateRange.map((date) => {
      var dayData = Object.values(dict.sourcesAll).reduce(
        (sum, curr) => {
          var dayValue =
            ReducedData.dataSourceAll[curr][date + 'T00:00:00'];
          // Combines 'unspecified epi link' and 'missing info' data for 'other' category
          if (curr === 'UNSPECIFIED EPI LINK') {
            dayValue =
              (ReducedData.dataSourceAll[curr][date + 'T00:00:00'] ||
                0) +
              (ReducedData.dataSourceAll[
                dict.sourcesAll['Missing Information']
              ][date + 'T00:00:00'] || 0);
          }

          if (this.props.selectedTab === dict.tabs.newCases) {
            sum[curr] = dayValue;
          } else {
            if (previousDayData && previousDayData[curr]) {
              sum[curr] = previousDayData[curr] + (dayValue || 0);
            } else {
              sum[curr] = dayValue;
            }
          }
          // let sum2 = sum;
          // debugger;
          return sum;
        },
        {
          date: dateFormater(date),
        },
      );

      previousDayData = dayData;

      return dayData;
    });

    tableData.reverse();

    // console.log(
    //   "tableData",
    //   tableData,
    //   ReducedData,
    //   getDatesRange("2020-02-20T00:00:00", "2020-07-28T00:00:00")
    // );

    const columns = Object.keys(dict.sourcesAll)
      .filter((item) => sourcesToDisplay.includes(item))
      .map((item) => {
        return {
          title: trans.bySource[item][this.props.lang],
          dataIndex: dict.sourcesAll[item],
          key: dict.sourcesAll[item],
          render: (text) => {
            if (text) {
              return text.toLocaleString();
            }
          },
          //width: "10%",
        };
      });

    columns.unshift({
      title: trans.date[this.props.lang],
      dataIndex: 'date',
      key: 'date',
      width: '20%',
    });

    return (
      <Table
        pagination={{ showSizeChanger: false }}
        columns={columns}
        dataSource={tableData}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default BySourceTable;
